import { toInteger } from "lodash";
import PropTypes from "prop-types";
import { graphql } from "gatsby";

export const query = graphql`
  fragment ShopifyMoneyV2Subquery on ShopifyMoneyV2 {
    amount
    currencyCode
  }

  fragment ShopifyProductVariantPricePairSubquery on ShopifyProductVariantPricePair {
    compareAtPrice {
      ...ShopifyMoneyV2Subquery
    }
    price {
      ...ShopifyMoneyV2Subquery
    }
  }
`;

const currencySymbols = {
  USD: "$", // US Dollar
  EUR: "€", // Euro
  CRC: "₡", // Costa Rican Colón
  GBP: "£", // British Pound Sterling
  ILS: "₪", // Israeli New Sheqel
  INR: "₹", // Indian Rupee
  JPY: "¥", // Japanese Yen
  KRW: "₩", // South Korean Won
  NGN: "₦", // Nigerian Naira
  PHP: "₱", // Philippine Peso
  PLN: "zł", // Polish Zloty
  PYG: "₲", // Paraguayan Guarani
  THB: "฿", // Thai Baht
  UAH: "₴", // Ukrainian Hryvnia
  VND: "₫", // Vietnamese Dong
};

function getFormattedPriceString(priceObject, locale) {
  if (priceObject && locale) {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: priceObject.currencyCode,
    }).format(priceObject.amount);
  } else {
    return "";
  }
}

function getFancyPriceString(priceObject, locale) {
  if (priceObject && locale) {
    let price;
    let intPrice = toInteger(priceObject.amount);
    if (intPrice == priceObject.amount) {
      price = intPrice;
    } else {
      price = new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
      }).format(priceObject.amount);
    }
    return `${getCurrencySymbol(priceObject.currencyCode)} ${price}`;
  } else {
    return "";
  }
}

function getCurrencySymbol(currencyCode) {
  return (
    (currencyCode in currencySymbols && currencySymbols[currencyCode]) ||
    currencyCode
  );
}

getFormattedPriceString.propTypes = {
  priceObject: PropTypes.object,
  locale: PropTypes.string,
};

getFancyPriceString.propTypes = {
  priceObject: PropTypes.object,
  locale: PropTypes.string,
};

getCurrencySymbol.propTypes = {
  currencyCode: PropTypes.string,
};

export { getFormattedPriceString, getCurrencySymbol, getFancyPriceString };
